import React from 'react';
import PropTypes from 'prop-types';
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import Arrays from "../../../utils/Arrays";
import {OverlayTrigger, Popover} from "react-bootstrap";
import nl2br from "../../../utils/nl2br";
import Button from "../../Button";

export default class CompaniesTabRow extends React.Component {

  static renderHead(id, checkOptions = null ) { // checkOptions = { text = '', checked = false, onChecked = (checked) => {} }
    return(
      <tr>
        {
          checkOptions !== null ?
            <th className="check-export-delete">
              <input
                type="checkbox"
                className="filled-in chk-col-blue-grey"
                id={'machine-tab-row-header-' + id}
                checked={checkOptions.checked}
                onChange={({target}) => checkOptions.onChecked(target.checked)}
              />
              <label htmlFor={'machine-tab-row-header-' + id}><strong>{checkOptions.text}</strong></label>
            </th>
            : null
        }
        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
        <th>{I18nUtils.tr('TR_NIF')}</th>
      </tr>
    );
  }

  constructor(init){
    super(init);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({target}){
    this.props.actionSelectItem(this.props.company, target.checked);
  }

  renderName(company) {
    if (company.error) {
      const popover = (
        <Popover id="popover-positioned-right" title="">{nl2br(company.error)}</Popover>
      );
      return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popover}>
          <span style={{ color: 'red'}}>{company.name}</span>
        </OverlayTrigger>
      );
    }
    return company.name;
  }

  render() {
    const { company } = this.props;
    return (
      <tr>
        {
          this.props.selectedIds !== null ?
            <td className="check-export-delete">
              <input
                type="checkbox"
                id={'check-company-' + company.id}
                className="filled-in chk-col-blue-grey"
                onChange={this.handleChange}
                checked={Arrays.contains(this.props.selectedIds, this.props.company.id)}
              />
              <label htmlFor={'check-company-' + company.id}>{this.props.selectText}</label>
            </td>
            : null
        }
        <td><strong>{this.renderName(company)}</strong></td>
        <td>{company.nif}</td>
        {this.props.action ?
          <td><Button text={this.props.actionText} className="btn-primary btn-sm btn-block" onClick={() => this.props.action(company)} /></td>
          : null }
      </tr>
    );
  }

}


CompaniesTabRow.propTypes = {
  company: PropTypes.objectOf(PropTypes.any).isRequired,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  selectText: PropTypes.string,
  action: PropTypes.any,
};

CompaniesTabRow.defaultProps = {
};




// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/companies/CompaniesTabRow.js